import React from "react";

import PatientLabSearchReport from "./pages/Report/PatientLabSearchReport";
import Registration from "./pages/NewRegistration";
import TatReport from "pages/TatReport";
import TatGraphicalReport from "pages/TatGraphicalReport";
import AppointmentCancellations from "pages/AppointmentCancellations.jsx";
import MarketingPersonBusinessReport from "pages/Report/MarketingPersonBusinessReport";
import EmployeeTargets from "pages/EmployeeTargets";
import MarketingPersonBusinessReportDetail from "pages/Report/MarketingPersonBusinessReport/MarketingPersonBusinessReportDetail";
import DoctorClinicRouter from "pages/DoctorClinicRouter";
import DoctorOPDChargeRouter from "pages/DoctorOPDChargeRouter";
import DoctorScheduleRouter from "pages/DoctorScheduleRouter";
import DoctorOPDBillItemRouter from "pages/DoctorOPDBillItemRouter";
import DoctorOPDBillPaymentRouter from "pages/DoctorOPDBillPaymentRouter";
import DoctorOPDAppointmentRouter from "pages/DoctorOPDBillPaymentRouter";

const Dashboard = React.lazy(() => import("./pages/Dashboard"));
const Branch = React.lazy(() => import("./pages/Branch"));
const Zone = React.lazy(() => import("./pages/Zone"));
const Area = React.lazy(() => import("./pages/Area"));
const Circular = React.lazy(() => import("./pages/Circular"));
const LabDepartment = React.lazy(() => import("./pages/LabDepartment"));
const CollectionType = React.lazy(() => import("./pages/CollectionType"));
const DepartmentType = React.lazy(() => import("./pages/DepartmentType"));
const FranchiseType = React.lazy(() => import("./pages/FranchiseType"));
const DoctorsDegree = React.lazy(() => import("./pages/DoctorsDegree"));
const DoctorsSepcialization = React.lazy(
  () => import("./pages/DoctorsSepcialization"),
);
const Organism = React.lazy(() => import("./pages/Organism"));
const InvestigationObservation = React.lazy(
  () => import("./pages/InvestigationObservation"),
);
const InvestigationSequence = React.lazy(
  () => import("./pages/InvestigationSequence"),
);
const Franchise = React.lazy(() => import("./pages/Franchise"));
const Department = React.lazy(() => import("./pages/Department"));
const Designation = React.lazy(() => import("./pages/Designation"));
const Employee = React.lazy(() => import("./pages/Employee"));
const EmployeeType = React.lazy(() => import("./pages/EmployeeType"));
const EmployeeCategory = React.lazy(
  () => import("./pages/EmployeeCategoryMaster"),
);
const EmployeeLeave = React.lazy(() => import("./pages/EmployeeLeave"));
const EmployeeLeaveLedger = React.lazy(
  () => import("./pages/EmployeeLeaveLedger"),
);
const EmployeeLeaveHistory = React.lazy(
  () => import("./pages/EmployeeLeaveHistory"),
);
const PaymentLedger = React.lazy(() => import("./pages/PaymentLedger"));
const CommissionLedger = React.lazy(() => import("./pages/CommissionLedger"));
const CreditTransfer = React.lazy(() => import("./pages/CreditTransfer"));
const Attendance = React.lazy(() => import("./pages/Attendance"));
const DiscountReasonMaster = React.lazy(
  () => import("./pages/DiscountReasonMaster"),
);
const PaymentMode = React.lazy(() => import("./pages/PaymentMode"));
const Role = React.lazy(() => import("./pages/Roles"));
const Document = React.lazy(() => import("./pages/DocumentMaster"));
const ShareType = React.lazy(() => import("./pages/ShareType"));
const SampleType = React.lazy(() => import("./pages/SampleType"));
const SampleCollection = React.lazy(() => import("./pages/SampleCollection"));
const SampleRejectionReason = React.lazy(
  () => import("./pages/SampleRejectionReason"),
);
const PaymentType = React.lazy(() => import("./pages/PaymentType"));
const InvestigationTest = React.lazy(
  () => import("./pages/InvestigationTestMaster"),
);
const InvestigationTemplate = React.lazy(
  () => import("./pages/InvestigationTemplateMaster"),
);
const EmpDiscountAllowed = React.lazy(
  () => import("./pages/EmployeeDiscountAllowed"),
);
const InvestigationNabl = React.lazy(
  () => import("./pages/InvestigationNablMaster"),
);
const OutsourceInvestigation = React.lazy(
  () => import("./pages/OutsourceInvestigationMaster"),
);
const OutsourceLab = React.lazy(() => import("./pages/OutsourceLabMaster"));
const Package = React.lazy(() => import("./pages/PackageMaster"));
const TestRate = React.lazy(() => import("./pages/TestRateMaster"));
const PackageInvestigationMaster = React.lazy(
  () => import("./pages/PackageInvestigationMaster"),
);
const InvestigationHelp = React.lazy(
  () => import("./pages/InvestigationHelpMaster"),
);
const Interpretation = React.lazy(
  () => import("./pages/InvestigationInterpretationMaster"),
);
const InvestigationDeliveryDays = React.lazy(
  () => import("./pages/InvestigationDeliveryDays"),
);
const InvestigationComment = React.lazy(
  () => import("./pages/InvestigationCommentMaster"),
);
const InvestigationDetails = React.lazy(
  () => import("./pages/InvestigationDetailsMaster"),
);
const Doctor = React.lazy(() => import("./pages/DoctorMaster"));
const EmployeeFranchiseDetails = React.lazy(
  () => import("./pages/EmploeeFranchiseDetailsMaster"),
);
const Patient = React.lazy(() => import("./pages/PatientMaster"));
// const Registration = React.lazy(() => import("./pages/NewRegistration"));
const Estimate = React.lazy(() => import("./pages/Estimate"));
const TestRateListExcel = React.lazy(() => import("./pages/TestRateListExcel"));
const FranchiseAdvancePayment = React.lazy(
  () => import("./pages/FranchiseAdvancePayment"),
);
const KycDocument = React.lazy(() => import("./pages/Kyc"));
const MachineData = React.lazy(() => import("./pages/MachineData"));
const InvestigationPackage = React.lazy(
  () => import("./pages/InvestigationPackage"),
);
const PatientAppointmentDetail = React.lazy(
  () => import("./pages/PatientAppointmentDetail"),
);
// const PatientLabSearchReport = React.lazy(
//   () => import("./pages/Report/PatientLabSearchReport"),
// );

const FranchisePatientReport = React.lazy(
  () => import("./pages/Report/FranchisePatientReport"),
);
const RoleWiseRedirectFranchisePatient = React.lazy(
  () => import("./pages/Report/RoleWiseRedirectFranchisePatient"),
);
const PannelWiseBusReport = React.lazy(
  () => import("./pages/Report/PannelWiseBusReport"),
);
const PannelWiseBusReportMedicity = React.lazy(
  () => import("./pages/Report/PannelWiseBusReportMedicity"),
);
const PannelWiseBusReportFranchise = React.lazy(
  () => import("./pages/Report/FranchisePannelWiseBusReport"),
);
const PaymentTypeSearchReport = React.lazy(
  () => import("./pages/Report/PaymentTypeSearchReport"),
);
const CommissionReport = React.lazy(
  () => import("./pages/Report/CommissionReport"),
);
const Observation = React.lazy(() => import("./pages/ObservationMaster"));
const InvestigationManager = React.lazy(
  () => import("./pages/InvestigationManager"),
);
const FranchiseFormat = React.lazy(
  () => import("./components/Common/FranchiseFormat"),
);
const NewFranchiseForm = React.lazy(
  () => import("./components/Common/NewFranchiseForm"),
);
const RejectedSample = React.lazy(() => import("./pages/RejectedSample"));
const LabDepartmentIPRate = React.lazy(
  () => import("./pages/LabDepartmentIPRate"),
);
const LabDepartmentWiseIPRates = React.lazy(
  () => import("./pages/LabDepartmentWisePercentage"),
);
const DoctorIPCalculation = React.lazy(() => import("./pages/IPCalculation"));
const Product = React.lazy(() => import("./pages/Product"));
const Vendor = React.lazy(() => import("./pages/Vendor"));
const TermsCondition = React.lazy(() => import("./pages/TermsCondition"));
const PurchaseOrder = React.lazy(() => import("./pages/PurchaseOrder"));
const ViewPurchaseOrder = React.lazy(
  () => import("./pages/PurchaseOrder/ViewPurchaseOrder"),
);
const ProductType = React.lazy(() => import("./pages/ProductType"));
const StockIn = React.lazy(() => import("./pages/StockIn"));
const AppointmentPayment = React.lazy(
  () => import("./pages/AppointmentPayment"),
);
const OnlinePaymentDetail = React.lazy(
  () => import("./pages/OnlinePaymentDetails"),
);
const MachineMaster = React.lazy(() => import("./pages/MachineMaster"));
const ObservationHostCode = React.lazy(
  () => import("./pages/ObservationHostCode"),
);
const ReportRole = React.lazy(() => import("./pages/ReportRole"));
const AssignRole = React.lazy(() => import("./pages/AssignRole"));
const ReceivedPayment = React.lazy(() => import("./pages/ReceivedPayment"));
const PackageCopyRate = React.lazy(() => import("./pages/PackageCopyRate"));
const Payments = React.lazy(() => import("./pages/Payments"));
const OnlinePaymentsAndReceivePayment = React.lazy(
  () => import("./pages/OnlinePaymentsAndReceivePayment"),
);
const PrintLabel = React.lazy(() => import("components/Common/PrintLabel"));
const CommissionReportLedger = React.lazy(
  () => import("pages/CommissionReportLedger"),
);
const AddObservationValuePage = React.lazy(
  () => import("pages/Report/PatientLabSearchReport/AddObservationValuePage"),
);
const DoctorPerformingCharges = React.lazy(
  () => import("pages/DoctorPerformingCharges"),
);
const MakePayment = React.lazy(() => import("pages/MakePayment"));
const PanelMaster = React.lazy(() => import("pages/PanelWiseItemMaster"));
const ViewFranchiseRate = React.lazy(() => import("pages/ViewFranchiseRate"));
const ViewFranchisePackageRate = React.lazy(
  () => import("pages/ViewFranchisePackageRate"),
);
const FranchiseCopyRate = React.lazy(() => import("pages/FranchiseCopyRates"));
const FranchiseInvestigationDetails = React.lazy(
  () => import("pages/FranchiseInvestigationDetails"),
);
const PanelMasterApproval = React.lazy(
  () => import("pages/PanelWiseItemMasterApproval"),
);
const FranchiseTopPerformer = React.lazy(
  () => import("pages/FranchiseTopPerformer"),
);

// NEW IMPORTS - Missing from original roleBasedRoutes.js
const LabDepartmentWiseCoordinatorRate = React.lazy(
  () => import("./pages/LabDepartmentWiseCoordinatorRate"),
);
const PatientCoordinatorsCommission = React.lazy(
  () => import("./pages/PatientCoordinatorsCommission"),
);
const PatientCoordinatorAgentsOnboardingApplication = React.lazy(
  () => import("./pages/PatientCoordinatorAgentsOnboardingApplication"),
);
const DoctorOnboardingApplication = React.lazy(
  () => import("./pages/DoctorOnboardingApplication"),
);

const DoctorOnboardingApplicationApproval = React.lazy(
  () => import("./pages/DoctorOnboardingApplicationApproval"),
);

const FranchiseOnboardingApplication = React.lazy(
  () => import("./pages/FranchiseOnboardingApplication"),
);

const FranchiseOnboardingApplicationApproval = React.lazy(
  () => import("./pages/FranchiseOnboardingApplicationApproval"),
);

const PatientCoordinatorAgentsOnboardingApplicationApproval = React.lazy(
  () => import("./pages/PatientCoordinatorAgentsOnboardingApplicationApproval"),
);

const MembershipCard = React.lazy(() => import("./pages/MembershipCard"));
const MembershipRates = React.lazy(() => import("./pages/MembershipRates"));
const MembershipOrder = React.lazy(() => import("./pages/MembershipOrder"));
const PatientCoordinatorAgents = React.lazy(
  () => import("./pages/PatientCoordinatorAgents"),
);
const NavbarSection = React.lazy(() => import("./pages/NavbarSection"));

const BookingCollectionReport = React.lazy(
  () => import("./pages/MisReport/BookingCollectionReport"),
);
const InvoiceReport = React.lazy(
  () => import("./pages/MisReport/InvoiceReport"),
);
const FranchiseInvoiceReport = React.lazy(
  () => import("./pages/Report/FranchiseInvoiceReport"),
);
const InvestigationReport = React.lazy(
  () => import("./pages/MisReport/InvestigationReport"),
);
const CollectionReport = React.lazy(
  () => import("./pages/MisReport/CollectionReport"),
);
const CardCollectionReport = React.lazy(
  () => import("./pages/MisReport/CardCollectionReport"),
);
const AllPaymentReport = React.lazy(
  () => import("./pages/MisReport/AllPaymentReport"),
);
const DiscountReport = React.lazy(
  () => import("./pages/MisReport/DiscountReport"),
);
const OutstandingReport = React.lazy(
  () => import("./pages/MisReport/OutstandingReport"),
);

const SampleCollectByBarcode = React.lazy(
  () => import("./pages/SampleCollectByBarcode"),
);

export const ROLE_BASED_ROUTES = [
  {
    path: "/",
    element: <Dashboard />,
  },
  {
    path: "/branch",
    element: <Branch />,
    label: "Branch",
  },
  {
    path: "/zone",
    element: <Zone />,
    label: "Zone",
  },
  {
    path: "/area",
    element: <Area />,
    label: "Area",
  },
  {
    path: "/circular",
    element: <Circular />,
    label: "Circular",
  },
  {
    path: "/collection-type",
    element: <CollectionType />,
    label: "Collection Type",
  },
  {
    path: "/lab-department",
    element: <LabDepartment />,
    label: "Lab Department",
  },
  {
    path: "/department-type",
    element: <DepartmentType />,
    label: "Department Type",
  },
  {
    path: "/franchise-type",
    element: <FranchiseType />,
    label: "Franchise Type",
  },
  {
    path: "/discount-reason",
    element: <DiscountReasonMaster />,
    label: "Discount Reason",
  },
  {
    path: "/doctors-degree",
    element: <DoctorsDegree />,
    label: "Doctors Degree",
  },
  {
    path: "/doctors-sepcialization",
    element: <DoctorsSepcialization />,
    label: "Doctors Specialization",
  },
  {
    path: "/organism",
    element: <Organism />,
    label: "Organism",
  },
  {
    path: "/investigation-observation",
    element: <InvestigationObservation />,
    label: "Investigation Observation",
  },
  {
    path: "/investigation-sequence",
    element: <InvestigationSequence />,
    label: "Investigation Sequence",
  },
  {
    path: "/department",
    element: <Department />,
    label: "Department",
  },
  {
    path: "/designation",
    element: <Designation />,
    label: "Designation",
  },
  {
    path: "/franchise-top-performer",
    element: <FranchiseTopPerformer />,
    label: "Franchise Top Performer",
  },
  {
    path: "/employee",
    element: <Employee />,
    label: "Employee",
  },
  {
    path: "/employeeType",
    element: <EmployeeType />,
    label: "Employee Type",
  },
  {
    path: "/employeeCategory",
    element: <EmployeeCategory />,
    label: "Employee Category",
  },
  {
    path: "/employeeLeave",
    element: <EmployeeLeave />,
    label: "Employee Leave",
  },
  {
    path: "/leaveLedgerSummary",
    element: <EmployeeLeaveLedger />,
    label: "Ledger Summary",
  },
  {
    path: "/leaveHistory",
    element: <EmployeeLeaveHistory />,
    label: "Leave History",
  },
  {
    path: "/attendance-report",
    element: <Attendance />,
    label: "Attendance Report",
  },
  {
    path: "/paymentMode",
    element: <PaymentMode />,
    label: "Payment Mode",
  },
  {
    path: "/payment-ledger",
    element: <PaymentLedger />,
    label: "Payment Ledger",
  },
  {
    path: "/commission-ledger",
    element: <CommissionLedger />,
    label: "Commission Ledger",
  },
  {
    path: "/roles",
    element: <Role />,
    label: "Roles",
  },
  {
    path: "/document",
    element: <Document />,
    label: "Document",
  },
  {
    path: "/shareType",
    element: <ShareType />,
    label: "Share Type",
  },
  {
    path: "/sampleType",
    element: <SampleType />,
    label: "Sample Type",
  },
  {
    path: "/sampleRejectionReason",
    element: <SampleRejectionReason />,
    label: "Sample Rejection Reason",
  },
  {
    path: "/sample-collect-by-barcode",
    element: <SampleCollectByBarcode />,
    label: "Sample Collect By Barcode",
  },
  {
    path: "/payment-type",
    element: <PaymentType />,
    label: "Payment Type",
  },
  {
    path: "/investigation-test",
    element: <InvestigationTest />,
    label: "Investigation/Test",
  },
  {
    path: "/investigation-manager",
    element: <InvestigationManager />,
    label: "Investigation Manager",
  },
  {
    path: "/sample-collection",
    element: <SampleCollection />,
    label: "Sample Collection",
  },
  {
    path: "/investigation-template",
    element: <InvestigationTemplate />,
    label: "Investigation Template",
  },
  {
    path: "/emp-discount-allowed",
    element: <EmpDiscountAllowed />,
    label: "Discount Allowed",
  },
  {
    path: "/performing-doctor-charges",
    element: <DoctorPerformingCharges />,
    label: "Doctor Performing Charges",
  },
  {
    path: "/investigation-nabl",
    element: <InvestigationNabl />,
    label: "Investigation NABL",
  },
  {
    path: "/outsource-investigation",
    element: <OutsourceInvestigation />,
    label: "Outsource Investigation",
  },
  {
    path: "/outsource-lab",
    element: <OutsourceLab />,
    label: "Outsource Lab",
  },
  {
    path: "/package",
    element: <Package />,
    label: "Package",
  },
  {
    path: "/test-rate",
    element: <TestRate />,
    label: "Test Rate",
  },
  {
    path: "/package-investigation",
    element: <PackageInvestigationMaster />,
    label: "Package Investigation",
  },
  {
    path: "/investigation-help",
    element: <InvestigationHelp />,
    label: "Investigation Help",
  },
  {
    path: "/investigation-interpretation",
    element: <Interpretation />,
    label: "Investigation Interpretation",
  },
  {
    path: "/investigation-deliveryDays",
    element: <InvestigationDeliveryDays />,
    label: "Investigation Delivery Days",
    roles: ["SUPER_FRANCHISE"],
  },
  {
    path: "/investigation-comment",
    element: <InvestigationComment />,
    label: "Investigation Comment",
  },
  {
    path: "/investigation-details",
    element: <InvestigationDetails />,
    label: "Investigation Details",
  },
  {
    path: "/doctors",
    element: <Doctor />,
    label: "Doctor Master",
  },
  {
    path: "/employee-franchise-details",
    element: <EmployeeFranchiseDetails />,
    label: "Employee Franchise Details",
  },
  {
    path: "/registration",
    element: <Registration />,
    label: "New Registration",
    roles: ["FRANCHISE_EMPLOYEE", "SUB_FRANCHISE", "SUPER_FRANCHISE"],
  },
  {
    path: "/investigationpackage",
    element: <InvestigationPackage />,
    label: "Investigation Package",
  },
  {
    path: "/patient-appointment-details",
    element: <PatientAppointmentDetail />,
    label: "Patient Appointment Details",
    roles: ["FRANCHISE_EMPLOYEE", "SUB_FRANCHISE", "SUPER_FRANCHISE"],
  },
  {
    path: "/panne-wise-bus-report",
    element: <PannelWiseBusReport />,
    label: "Pannel Wise Business Report",
    roles: ["FRANCHISE_EMPLOYEE", "SUB_FRANCHISE", "SUPER_FRANCHISE"],
  },
  {
    path: "/medicity-panel-wise-bus-report",
    element: <PannelWiseBusReportMedicity />,
    label: "Medicity Pannel Wise Business Report",
  },
  {
    path: "/patient-wise-search-report",
    element: <PatientLabSearchReport />,
    label: "Result Entry",
  },
  {
    path: "/observation-entry",
    element: <AddObservationValuePage />,
    label: "Observation Entry",
  },
  {
    path: "/role-wise-patient-report",
    element: <RoleWiseRedirectFranchisePatient />,
    label: "Role Wise Patient Report",
    roles: ["SUPER_FRANCHISE", "FRANCHISE_EMPLOYEE", "SUB_FRANCHISE"],
  },
  {
    path: "/payment-type-search-report",
    element: <PaymentTypeSearchReport />,
    label: "Payment Type Search Report",
  },
  {
    path: "/observation",
    element: <Observation />,
    label: "Observation Master",
  },
  {
    path: "/estimate",
    element: <Estimate />,
    label: "Estimate",
    roles: ["SUPER_FRANCHISE", "FRANCHISE_EMPLOYEE", "SUB_FRANCHISE"],
  },
  {
    path: "/franchise-advance-payment-list",
    element: <FranchiseAdvancePayment />,
    label: "Franchise Advance Payment",
    roles: ["FRANCHISE_EMPLOYEE", "SUB_FRANCHISE", "SUPER_FRANCHISE"],
  },
  {
    path: "/kyc-documents",
    element: <KycDocument />,
    label: "KYC",
  },
  {
    path: "/machine-data",
    element: <MachineData />,
    label: "Machine Data",
  },
  {
    path: "/test-rate-list-excel",
    element: <TestRateListExcel />,
    label: "Test Rate List Excel",
    roles: [
      "SUPER_ADMIN",
      "CEO",
      "ACCOUNTANT",
      "FLOOR_MANAGER",
      "FLOOR MANAGER",
    ],
  },
  {
    path: "/appointment-payment",
    element: <AppointmentPayment />,
    label: "Patient Appointment Payment",
    roles: ["FRANCHISE_EMPLOYEE", "SUB_FRANCHISE", "SUPER_FRANCHISE"],
  },
  {
    path: "/online-payment-details",
    element: <OnlinePaymentDetail />,
    label: "Online Payment Details",
    roles: ["FRANCHISE_EMPLOYEE", "SUB_FRANCHISE", "SUPER_FRANCHISE"],
  },
  {
    path: "/machine-master",
    element: <MachineMaster />,
    label: "Machine Master",
  },
  {
    path: "/observation-host-code",
    element: <ObservationHostCode />,
    label: "Observation Host Code",
  },
  {
    path: "/report-role",
    element: <ReportRole />,
    label: "Report Role",
  },
  {
    path: "/commission-report-ledger",
    element: <CommissionReportLedger />,
    label: "Commission Report Ledger",
    roles: ["FRANCHISE_EMPLOYEE", "SUPER_FRANCHISE"],
  },
  {
    path: "/assign-role",
    element: <AssignRole />,
    label: "Assign Report Role",
  },
  {
    path: "/received-payment",
    element: <ReceivedPayment />,
    label: "Received Payment",
  },
  {
    path: "/package-copy-rate",
    element: <PackageCopyRate />,
    label: "Package Copy Rate",
    roles: ["FRANCHISE_EMPLOYEE", "SUPER_FRANCHISE"],
  },
  {
    path: "/payments",
    element: <Payments />,
    label: "Payments",
  },
  {
    path: "/online-payments-and-receive-payment",
    element: <OnlinePaymentsAndReceivePayment />,
    label: "Online Payment Details Type",
  },
  {
    path: "/print-label-exe",
    element: <PrintLabel />,
    label: "Print Label",
  },
  {
    path: "/franchiseFormat",
    element: <FranchiseFormat />,
    label: "Franchise Format",
  },
  {
    path: "/new-franchise",
    element: <NewFranchiseForm />,
    label: "Document & Download",
  },
  {
    path: "/rejected-sample-appointments",
    element: <RejectedSample />,
    label: "Sample Rejected Appointments",
  },
  {
    path: "/lab-department-ip-rate",
    element: <LabDepartmentIPRate />,
    label: "Lab Department IP Rates",
  },
  {
    path: "/lab-department-wise-ip-rates",
    element: <LabDepartmentWiseIPRates />,
    label: "Lab Department Wise IP Rates",
  },
  {
    path: "/doctor-ip-calculation",
    element: <DoctorIPCalculation />,
    label: "Doctor IP Calculation",
  },
  {
    path: "/product-type",
    element: <ProductType />,
    label: "Product Type",
  },
  {
    path: "/product",
    element: <Product />,
    label: "Product",
  },
  {
    path: "/vendor",
    element: <Vendor />,
    label: "Vendor",
  },
  {
    path: "/terms-condition",
    element: <TermsCondition />,
    label: "Terms Condition",
  },
  {
    path: "/purchase-order",
    element: <PurchaseOrder />,
    label: "Purchase Order",
  },
  {
    path: "/view-purchase-order",
    element: <ViewPurchaseOrder />,
    label: "View Purchase Order",
  },
  {
    path: "/stock-in",
    element: <StockIn />,
    label: "Manage Stocks",
  },

  // NEW ROUTES - Added from App.js
  {
    path: "/lab-department-wise-coordinator-rates",
    element: <LabDepartmentWiseCoordinatorRate />,
    label: "Lab Department Wise Coordinator rates",
  },
  {
    path: "/patient-coordinator-commission",
    element: <PatientCoordinatorsCommission />,
    label: "Patient Coordinator Commission",
  },
  {
    path: "/patient-coordinator-agent-onboarding-application",
    element: <PatientCoordinatorAgentsOnboardingApplication />,
    label: "Patient Coordinator Agents Onboarding Application",
  },
  {
    path: "/doctor-onboarding-application",
    element: <DoctorOnboardingApplication />,
    label: "Doctor Onboarding Application",
  },
  {
    path: "/doctor-onboarding-application-approval",
    element: <DoctorOnboardingApplicationApproval />,
    label: "Doctor Onboarding Application Approval",
  },
  {
    path: "/franchise-onboarding-application",
    element: <FranchiseOnboardingApplication />,
    label: "Franchise Onboarding Application",
  },
  {
    path: "/franchise-onboarding-application-approval",
    element: <FranchiseOnboardingApplicationApproval />,
    label: "Franchise Onboarding Application Approval",
  },
  {
    path: "/patient-coordinator-agent-onboarding-application-approval",
    element: <PatientCoordinatorAgentsOnboardingApplicationApproval />,
    label: "Patient Coordinator Agent Onboarding Application Approval",
  },
  {
    path: "/membership-card",
    element: <MembershipCard />,
    label: "Membership Card",
  },
  {
    path: "/membership-rates",
    element: <MembershipRates />,
    label: "Membership Rates",
  },
  {
    path: "/membership-orders",
    element: <MembershipOrder />,
    label: "Membership Orders",
  },
  {
    path: "/patient-coordinator-agents",
    element: <PatientCoordinatorAgents />,
    label: "Patient Coordinator Agents",
  },
  {
    path: "/section",
    element: <NavbarSection />,
    label: "Section",
  },
  {
    path: "/card-collection-report",
    element: <CardCollectionReport />,
    label: "Card Collection Report",
  },
  {
    path: "/booking-collection-report",
    element: <BookingCollectionReport />,
    label: "Booking Collection Report",
  },
  {
    path: "/invoice-report",
    element: <InvoiceReport />,
    label: "Invoice Report",
  },
  {
    path: "/franchise-invoice-report",
    element: <FranchiseInvoiceReport />,
    label: "Franchise Invoice Report",
  },
  {
    path: "/investigation-wise-report",
    element: <InvestigationReport />,
    label: "Investigation Wise Report",
  },
  {
    path: "/collection-report",
    element: <CollectionReport />,
    label: "Collection Report",
  },
  {
    path: "/all-payment-report",
    element: <AllPaymentReport />,
    label: "All Payment Report",
  },
  {
    path: "/discount-report",
    element: <DiscountReport />,
    label: "Discount Report",
  },
  {
    path: "/outstanding-report",
    element: <OutstandingReport />,
    label: "Outstanding Report",
  },

  // Super Franchise routes
  {
    path: "/franchise",
    element: <Franchise />,
    label: "Franchise",
    roles: ["SUPER_FRANCHISE", "FRANCHISE_EMPLOYEE"],
  },
  {
    path: "/credit-transfer",
    element: <CreditTransfer />,
    label: "Credit Transfer",
    roles: ["SUPER_FRANCHISE", "FRANCHISE_EMPLOYEE"],
  },
  {
    path: "/commission-report",
    element: <CommissionReport />,
    label: "Commission Report",
    roles: ["SUPER_FRANCHISE", "FRANCHISE_EMPLOYEE"],
  },
  {
    path: "/patient-report",
    element: <FranchisePatientReport />,
    label: "Patient Report",
    roles: ["SUB_FRANCHISE", "SUPER_FRANCHISE", "FRANCHISE_EMPLOYEE"],
  },
  {
    path: "/advance-payment",
    element: <MakePayment />,
    label: "Make Advance Payment",
    roles: ["SUB_FRANCHISE", "FRANCHISE_EMPLOYEE", "SUPER_FRANCHISE"],
  },

  // Franchise Employee routes
  {
    path: "/patient",
    element: <Patient />,
    label: "Patient",
    roles: ["SUB_FRANCHISE", "FRANCHISE_EMPLOYEE", "SUPER_FRANCHISE"],
  },
  {
    path: "/panel-master",
    element: <PanelMaster />,
    label: "Franchise Copy Rates",
    roles: ["FRANCHISE_EMPLOYEE", "SUPER_FRANCHISE"],
  },
  {
    path: "/view-franchise-rates",
    element: <ViewFranchiseRate />,
    label: "View Franchise Rates",
    roles: ["FRANCHISE_EMPLOYEE", "SUPER_FRANCHISE", "SUB_FRANCHISE"],
  },
  {
    path: "/view-franchise-package-rates",
    element: <ViewFranchisePackageRate />,
    label: "View Franchise Package Rates",
    roles: ["FRANCHISE_EMPLOYEE", "SUPER_FRANCHISE", "SUB_FRANCHISE"],
  },
  {
    path: "/franchise-copy-rates",
    element: <FranchiseCopyRate />,
    label: "Medicity Franchise Copy Rates",
    roles: ["ACCOUNTANT", "CEO"],
  },
  {
    path: "/franchise-investigation-details",
    element: <FranchiseInvestigationDetails />,
    label: "Franchise Investigation Details",
    roles: ["FRANCHISE_EMPLOYEE", "SUB_FRANCHISE", "SUPER_FRANCHISE"],
  },
  {
    path: "/panel-master-approval",
    element: <PanelMasterApproval />,
    label: "Franchise Copy Rates Approval",
    roles: ["CEO"],
  },
  {
    path: "/franchise-panel-wise-bus-report",
    element: <PannelWiseBusReportFranchise />,
    label: "Franchise Pannel Wise Business Report",
    roles: ["FRANCHISE_EMPLOYEE", "SUPER_FRANCHISE"],
  },
  {
    path: "/tat-report",
    element: <TatReport />,
    label: "TAT Report",
  },
  {
    path: "/tat-graphical-report",
    element: <TatGraphicalReport />,
    label: "TAT Graphical Report",
  },
  {
    path: "/appointment-cancellations",
    element: <AppointmentCancellations />,
    label: "Appointment Cancellations",
  },
  {
    path: "/marketing-person-business-report",
    element: <MarketingPersonBusinessReport />,
    label: "Marketing Person Business Report",
  },
  {
    path: "/employee-targets",
    element: <EmployeeTargets />,
    label: "Employee Targets",
  },
  {
    path: "/marketing-person-business-report-detail",
    element: <MarketingPersonBusinessReportDetail />,
    label: "Marketing Person Business Report",
  },
  {
    path: "/doctor-clinic-router",
    element: <DoctorClinicRouter />,
    label: "Doctor Clinic Router",
  },
  {
    path: "/doctor-opd-charge-router",
    element: <DoctorOPDChargeRouter />,
    label: "Doctor OPD Charge Router",
  },
  {
    path: "/doctor-schedule-router",
    element: <DoctorScheduleRouter />,
    label: "Doctor Schedule Router",
  },
  {
    path: "/doctor-opd-bill-item-router",
    element: <DoctorOPDBillItemRouter />,
    label: "Doctor POD Bill Item Router",
  },
  {
    path: "/doctor-opd-bill-payment-router",
    element: <DoctorOPDBillPaymentRouter />,
    label: "doctor-opd-bill-payment-router",
  },
  {
    path: "/doctor-opd-appointment-router",
    element: <DoctorOPDAppointmentRouter />,
    label: "doctor-opd-appointment-router",
  },
];

export const PUBLIC_ROUTES = [
  "/login",
  "/receipt",
  "/receipt-patient",
  "/receipt-patient-credit-mode",
  "/receipt-trf-work",
  "/invoice",
  "/invoice-new-registration-patient-receipt",
  "/ResultEntryPdf",
  "/SampleReportPdf",
  "/patient-document",
  "/ResultEntryHtmlPdf",
  "/ResultEntryReactPdf",
  "/medicity/reports/:token",
  "/appointment-payment/advancepayment-success",
  "/appointment-payment/advancepayment-failure",
];
